import React, {Component} from 'react';
import ReCaptcha from '../common/recaptcha.component';
import {requestOtp} from '../../services/rest';
import Validator from '../../utils/Validator';
import {USERNAME_VALIDATION_ERROR_MESSAGE} from '../../utils/constants';
import ErrorHandler from '../../utils/error-handler';
import TaggingHelper from '../../tagging/tagging-helper';
import WarningPopup from './OtpPopUp';

class ReceivedOtp extends Component {
  defaultState = {
    username: '',
    isUsernameValid: false,
    token: null,
    usernameActive: false,
    showPopup: true,
  };

  constructor(props) {
    super(props);
    if (props.data && props.data.previousState) {
      this.state = {
        ...props.data.previousState,
        token: null
      };
    } else {
      this.state = this.defaultState;
    }
  }

  activateField = (e) => {
    this.setState({
      [`${e.target.name}Active`]: true,
    });
  };

  disableField = (e) => {
    this.setState({
      [`${e.target.name}Active`]: false,
    });
  };

  _onVerifyCallback = (token) => {
    this.setState ({
      token: token,
    });
  };

  _onExpiredCallback = () => {
    this.setState ({ token: null });
  };

  handleButtonClick = () => {
    this.setState ({showPopup: true});
  };

  handleContinue = () => {
    this.setState ({showPopup: false});
    this.props.goto ('LOGIN_OTP');
  };

  closePopUp = () => {
    this.setState ({
      showPopup: false,
    });
  };

  togglePopup = () => {
  this.setState ({showPopup: true});
};

  sendtOtp = (e) => {
    e.preventDefault ();
    const {goto} = this.props;
    this.props.showUILoader (true);
    requestOtp (this.state.username, this.state.token)
      .then (response => {
        if (response.data && response.data.result) {
          const message = response.data.result.message || '';
          const data = {
            message,
            currentState: this.state
          };
          goto ('ENTER_OTP', data);
        } else {
          throw new Error ('UNEXPECTED_ERROR');
        }
      })
      .catch(error => {
        ErrorHandler.handleLoginOtpRequestError (
          error,
          goto,
          this.state,
          'LOGIN_OTP'
        );
        const errorMessage = ErrorHandler.getErrorMessage (error).errorMessage;
        TaggingHelper.loginApiErrorEvent (errorMessage);
      })
      .finally(() => {
        this.props.showUILoader(false);
      });
  };

  onUsernameChange = (e) => {
    this.setState({
      username: e.target.value,
      isUsernameValid: Validator.isValidUsername(e.target.value),
    });
  };

  componentDidMount() {
    TaggingHelper.loginOTPLandingEvent();
  }

  onGoBack = () => {
    this.props.goto ('LOGIN');
  };

  handleClosePopUp = () => {
  this.setState ({showPopup: false});
};


  render () {
    const { goto } = this.props;
    const { isUsernameValid, token, username, usernameActive, showPopup } = this.state;
    return (
      <>
        {showPopup ? (
          <WarningPopup onClose={this.handleClosePopUp} />
        ) : (
          <React.Fragment>
            <div className="card-header">
              <h2>Login with an OTP</h2>
              <p>
                {"Don't have an account yet? "}
                <button
                  type="button"
                  className="button-link"
                  onClick={() => goto('CREATE_PROFILE')}
                  automationid="LOGIN_FORM_RECEIVEDOTP_1"
                >
                  {`  Register now `}
                </button>
              </p>
            </div>
            <div className="field-group">
              <label className={usernameActive || username ? 'active' : ''}>
                {'Cell number or email/username'}
              </label>
              <input
                onChange={this.onUsernameChange}
                value={username}
                type="text"
                name="username"
                onFocus={this.activateField}
                onBlur={this.disableField}
                automationid="LOGIN_FORM_RECEIVEDOTP_2"
                required
                className={
                  !usernameActive && username && !isUsernameValid ? 'error' : ''
                }
              />
              {!usernameActive &&
                username &&
                !isUsernameValid &&
                <p className="infield-error-label">
                  {USERNAME_VALIDATION_ERROR_MESSAGE}
                </p>}
            </div>
            <div className="captcha-wrapper">
              <ReCaptcha
                sitekey={'6LdNAAwUAAAAALEhZyYgkqFtXUPKVhD5Fj2XaWUm'}
                verifyCallback={this._onVerifyCallback}
                expiredCallback={this._onExpiredCallback}
              />
            </div>
            <div className="action-button-wrapper">
              <button
                type="submit"
                className="btn btnRed"
                disabled={!isUsernameValid || !token}
                onClick={e => this.sendtOtp(e)}
                automationid="LOGIN_FORM_RECEIVEDOTP_3"
              >
                SEND OTP
              </button>
            </div>
            <div className="action-button-wrapper">
              <button
                type="button"
                className="btn btnWhite"
                onClick={this.onGoBack}
                automationid="LOGIN_FORM_RECEIVEDOTP_4"
              >
                LOGIN WITH PASSWORD
              </button>
            </div>
            <div className="card-footer">
              <p>
                Forgot your{" "}
                <button
                  type="button"
                  className="button-link"
                  onClick={() => {
                    goto("FORGOT_USERNAME");
                  }}
                  automationid="LOGIN_FORM_RECEIVEDOTP_5"
                >
                  email/username
                </button>{" "}
                ?
              </p>
            </div>
        
          </React.Fragment>
        )}
      </>
    );
  }
}

export default ReceivedOtp;
